import { gql } from '@apollo/client';

export const GET_TERMS_OF_SERVICE = gql`
  query GetTermsOfService($email: String!, $skip: Int = 0, $take: Int = 1000) {
    termsOfService(email: $email, skip: $skip, take: $take) {
      email
      version
    }
  }
`;
